import React, { useState } from 'react';

const seoTabsData = [
  {
    id: 'site-audit',
    title: 'Site Audit',
    contentTitle: 'Site Audit',
    desc: 'A site audit pinpoints website issues that hinder search engine visibility and user experience. It also reveals opportunities for improvement of your brand’s website. You can improve your search rankings, attract more organic traffic, and increase conversions if you address these problems at the correct time. Site audit provides a roadmap to optimize a website and achieve better online performance and business growth. Our SEO agency in Pakistan provides multiple solutions to help you with site audit to:',
    bullets: [
      'Identify Technical SEO Issues',
      'Analyze On-Page SEO Elements',
      'Assess Website Structure and Navigation',
      'Evaluate Backlink Profile',
      'Content Optimization Status'
    ],
    bottomText: 'Our affordable SEO services recognize problems like crawl errors, slow loading speeds, broken links, and mobile-friendliness. We also analyze the quality and quantity of backlinks pointing to your site. Get a detailed report with prioritized steps to fix identified issues and improve your website’s overall SEO performance with our SEO company.'
  },
  {
    id: 'competitive-analysis',
    title: 'Competitive Analysis',
    contentTitle: 'Competitive Analysis',
    desc: 'We examine competitors’ performance, strengths, and shortcomings to provide businesses with useful information. These insights help us to improve strategies and overcome errors. Competitive analysis helps businesses stay ahead of industry trends and make well-informed decisions. Our SEO company is here to help you in competitive analysis to:',
    bullets: [

      'Identify key competitors',
      'Analyze competitors’ website performance',
      'Analyze competitors’ SEO strategies',
      'Analyze competitors’ marketing efforts',
      'Evaluate competitors’ keyword rankings',
      'Evaluate competitors’ backlink profiles',
      'Evaluate competitors’ social media presence',
      'Gain a competitive edge',
      'Provide detailed reports'
    ],
    bottomText: 'Our SEO agency goes beyond surface level observations and provides you with a complete understanding of your competitors’ online strategies. We analyze your website performance, SEO tactics, content, keywords, backlinks, and social media activities. Our SEO services in Karachi offer detailed reports to tell you how you can refine your strategies and rank higher.'
  },
  {
    id: 'industry-research',
    title: 'Industry Research',
    contentTitle: 'Industry Research',
    desc: 'Industry research tells about the latest trends, challenges, and opportunities within their specific market. We identify emerging trends and capitalize on new opportunities with the proper industry research that tells us about market size, growth, customer behavior, and technological advancements. Industry research also helps brands to mitigate risks and improve their services. It can help to:',
    bullets: [
      'Identify industry trends and technologies.',
      'Analyze market size',
      'Analyze growth potential',
      'Analyze customer demographics',
      'Evaluate industry best practices',
      'Evaluate benchmarks',
      'Insights into competitor strategiesInsights into market share'
    ],
    bottomText: 'Experts Communication offers you actionable insights into your industry’s dynamics along with data collection. Our local SEO services analyze market trends, growth opportunities, customer behavior, and competitor strategies.'
  },
  {
    id: 'keyword-research',
    title: 'Keyword Research',
    contentTitle: 'Keyword Research',
    desc: 'Keyword research attracts the right audience to the website. It identifies the specific words and phrases that potential customers use when they search for your products or services. Effective keyword research connects businesses with users who have a genuine interest in what they offer. It leads to more qualified traffic and higher conversion rates. Keyword research helps to:',
    bullets: [
      'Identify high volume and relevant keywords',
      'Analyze keyword competitiveness',
      'Discover long tail keywords',
      'Map keywords',
      'Provide a comprehensive keyword strategy for content creation'
    ],
    bottomText: 'Our best SEO service in Pakistan provides keyword research services with advanced tools and techniques that tell you about the most valuable keywords. We analyze search volume, competition, and user intent to develop a strategic keyword map for content creation and optimization efforts.'
  },
  {
    id: 'keywords-mapping',
    title: 'Keywords Mapping',
    contentTitle: 'Keywords Mapping',
    desc: 'Keyword mapping organizes businesses’ SEO efforts and aligns the website content with relevant search queries. We create a clear and logical site structure when assigning specific keywords to individual pages on a website. Keyword mapping improves search engine visibility for targeted terms and makes pages visible according to the page’s intent. Our SEO agency helps you in keyword mapping to:',
    bullets: [

      'Organize your target keywords',
      'Assign relevant keywords to specific pages',
      'Create a clear site structure',
      'Aligns site structure with user search intent',
      'Optimize website navigation',
      'Optimize internal linking'
    ],
    bottomText: 'We offer the best keyword mapping services to structure your website for optimal SEO performance. We identify keywords and assign them to the most relevant pages on your site, creating a clear and organized structure that aligns with user search intent.'
  },
  {
    id: 'content-optimization',
    title: 'Content Optimization and Marketing',
    contentTitle: 'Content Optimization and Marketing',
    desc: 'Content optimization and marketing connect brands with their target audience. It establishes authority and drives conversions for the brand’s growth. Businesses attract and retain customers with valuable and engaging content. Quality content helps brands build brand awareness and grow their revenue. Great content also helps in SEO, and it brings higher organic rankings and more website traffic. Our content optimization and marketing process includes a lot more, but some of them are:',
    bullets: [
      'In-depth Audience Research',
      'Keyword Research and Strategy',
      'Content Creation and Optimization',
      'Content Distribution and Promotion',
      'Performance Monitoring and Analysis'
    ],
    bottomText: 'Content marketing is an off-page SEO method. At our SEO agency, our off-page SEO services conduct thorough research to rank your site. Our on-page SEO team creates compelling and optimized content while our off-page efforts push your website towards ranking.'
  },
  {
    id: 'technical-integrations',
    title: 'Technical Integrations',
    contentTitle: 'Technical Integrations',
    desc: 'Technical integrations connect various software systems and platforms for businesses to automate workflows and improve data accuracy. It also improves communication and gives a holistic view of their processes. Technical integrations increase productivity and reduce manual errors to provide a quality customer experience. Our technical integration involves:',
    bullets: [
      'Platform Assessment and Compatibility Analysis',
      'API Development and Configuration',
      'Data Mapping and Migration',
      'API Integration and Deployment',
      'Testing and Deployment'
    ],
    bottomText: 'Our b2b SEO agency in Pakistan analyzes your current technical infrastructure and identifies opportunities for strategic integrations to optimize your business processes. We handle the complexities of connecting your systems to provide data integrity and smooth functionality.'
  },
  {
    id: 'backlinks',
    title: 'Backlinks',
    contentTitle: 'Backlinks',
    desc: 'Backlinks are like votes of confidence from other websites. Backlinks build value and trust before the search engines when a website links to yours. It makes your content reliable for Google. Strong backlinks can improve a website’s authority and improve search engine rankings. They are also a big reason for driving more organic traffic and amplifying online visibility. Our off page SEO services are here to offer more than the one mentioned:',
    bullets: [
      'Evaluate Your Existing Backlink Profile',
      'Analyze Your Competitors’ Backlinks',
      'Identifying High Authority and Relevant Link Sources',
      'Implement Ethical and Effective Link Building Strategies',
      'Monitor and Maintain Your Backlink Profile'
    ],
    bottomText: 'We examine your backlink profile and develop a tailored strategy to acquire authoritative and relevant backlinks that strengthen your website’s SEO performance and drive sustainable growth.'
  },
  {
    id: 'rank-tracking',
    title: 'Rank Tracking',
    contentTitle: 'Rank Tracking',
    desc: 'Rank tracking helps us to understand the performance of your website in search engine results pages (SERPs) for specific keywords over time. We analyze the effectiveness of our SEO efforts by monitoring the keyword rankings properly. We also keep an eye on the search visibility, traffic potential, and overall online performance with consistent rank tracking. We:',
    bullets: [
      'Identify Relevant Keywords',
      'Set Up Comprehensive Rank Tracking',
      'Provide Regular and Detailed Reports',
      'Analyze Ranking Fluctuations and Identify Causes',
      'Identify Opportunities for Further Optimization'
    ],
    bottomText: 'We set up strong rank tracking for your business needs with advanced techniques and tools. We also provide you with regular, insightful reports and analysis to help you understand your search engine performance. Our team makes data driven decisions to improve your online visibility and attract more organic traffic from your target audience.'
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    contentTitle: 'Monitoring',
    desc: 'We implement website monitoring to check the performance of the website and its security. We make sure that the website provides a positive user experience and prevents potential disruptions. A bad website can result in lost revenue and reputational damage. If we monitor the websites actively, we can detect the issue in an early stage and resolve it as soon as possible. It will also minimize downtime and increase the productivity of your website. We implement:',
    bullets: [
      'Uptime Monitoring',
      'Performance Monitoring',
      'Security Monitoring',
      'Error Monitoring',
      'Content Monitoring',
      'Real Time Alerts and Notifications',
      'Detailed Performance Reports'
    ],
    bottomText: 'Our SEO company provides vigilant monitoring of your website, and we act as an early warning system to detect and address potential problems. Our SEO team monitors your website constantly and optimizes it for top performance even after your project’s completion.'
  },
  {
    id: 'monthly-reports',
    title: 'Monthly Reports',
    contentTitle: 'Monthly Reports',
    desc: 'The monthly reports hold a structured overview of your website’s performance over the past month. We include all the data related to key metrics, progress, and areas for potential improvement. These reports help to track the effectiveness of online strategies and to understand user behaviour we’ve implemented in the past months. We ensure transparency between our clients and the company to provide hassle free services that positively impact your business. Our monthly reports include:',
    bullets: [
      'Website Traffic',
      'Search Engine Rankings',
      'User Engagement',
      'Conversion Tracking',
      'Website Performance',
      'Backlink Analysis Summary',
      'User Behaviour',
      'User Activity',
      'Keywords Landing',
      'Key Highlights and Recommendations'
    ],
    bottomText: 'At our SEO agency in Karachi, we offer clear insights and practical recommendations that align with your business goals. We help you understand your website’s performance and track your progress.'
  }
];

function SeoServicesTabs() {
  const [activeTabId, setActiveTabId] = useState('site-audit');

  const activeTab =
    seoTabsData.find((item) => item.id === activeTabId) || seoTabsData[0];

  return (
    <section className="seo-tabs-section">
      <div className="container">
        {/* Section Header: 2-Column Row */}
        <div className="seo-tabs-header-row">
          <div className="seo-tabs-header-left">
            <h2 className="seo-tabs-main-title">
              What You’ll Expect When Getting the <span className="seo-red-title">Best SEO Services</span>
            </h2>
          </div>
          <div className="seo-tabs-header-right">
            <p className="seo-tabs-header-desc">
              In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets.
            </p>
            <p className="seo-tabs-header-desc">
              In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets.
            </p>
          </div>
        </div>

        {/* Tabs Main Grid: Left Vertical Sidebar Tabs, Right White Content Box */}
        <div className="seo-tabs-main-grid">
          {/* Left Side: Dark Vertical Sidebar Tabs */}
          <div className="seo-tabs-sidebar">
            <ul className="seo-tabs-list">
              {seoTabsData.map((item) => {
                const isActive = item.id === activeTabId;
                return (
                  <li key={item.id} className="seo-tab-item">
                    <button
                      className={`seo-tab-button ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTabId(item.id)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Right Side: White Tab Content Card */}
          <div className="seo-tab-content-card">
            <h3 className="seo-tab-content-heading">
              {activeTab.contentTitle}
            </h3>

            <p className="seo-tab-content-desc">
              {activeTab.desc}
            </p>

            {activeTab.bullets && activeTab.bullets.length > 0 && (
              <ul className="seo-tab-bullets-list">
                {activeTab.bullets.map((bullet, idx) => (
                  <li key={idx} className="seo-tab-bullet-item">
                    {bullet}
                  </li>
                ))}
              </ul>
            )}

            {activeTab.bottomText && (
              <p className="seo-tab-content-bottom">
                {activeTab.bottomText}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeoServicesTabs;
